import React from "react";
import { useLang } from "../context/LanguageContext";

const styles = {
  available: "border-[#262421] text-[#8A857D]",
  in_stock: "border-[#262421] text-[#8A857D]",
  sold_out: "border-[#5a2a2a] text-[#c88]",
  coming_soon: "border-[#3a3a2a] text-[#c9b978]",
  limited_release: "border-[#C49A6C] text-[#C49A6C]",
};

export const StatusBadge = ({ status, className = "" }) => {
  const { t } = useLang();
  const s = styles[status] || styles.available;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-block text-[10px] uppercase tracking-[0.2em] border px-3 py-1 ${s} ${className}`}
    >
      {t(status)}
    </span>
  );
};
